<template>
  <div class="spinner-wheel_waiting">
    <img src="@/assets/images/pointer.svg" alt="pointer" class="spinner-wheel_pointer">
    <img src="@/assets/images/wheel.svg" alt="spinner wheel" class="spinner-wheel_wheel">
    <div class="spinner-wheel_box horizontal layout center center-justified">
      <span v-if="slide.metadata.wheelStatus === 'spinning'">
        {{ $t('theWheelSpinning') }}
      </span>
      <span v-if="slide.metadata.wheelStatus !== 'spinning'">
        {{ $t('waitToSpinTheWheel') }}
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.spinner-wheel_waiting {
  max-width: 390px;
  position: relative;
  margin: 0 auto;
  margin-bottom: 60px;
  overflow: hidden;
}

.spinner-wheel_wheel {
  width: 100%;
  animation: spin 30s linear infinite;
}

.spinner-wheel_pointer {
  position: absolute;
  top: 30px;
  left: 30px;
  z-index: 1;
}

.spinner-wheel_box {
  background: #FFFFFF;
  box-shadow: 0px 5.5142px 5.5142px rgba(0, 0, 0, 0.05);
  border-radius: 14px;
  color: #333;
  text-align: center;
  position: absolute;
  top: 50%;
  width: 100%;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.4;
  transform: translateY(-50%);
}
</style>
